import { CONFIG } from '../config';

/**
 * 화면 흔들림 효과 관리
 */
export class ScreenShake {
    private intensity: number = 0;
    private duration: number = 0;
    private timer: number = 0;
    private offsetX: number = 0;
    private offsetY: number = 0;

    /**
     * 화면 흔들림 트리거
     */
    shake(intensity?: number, duration?: number): void {
        this.intensity = intensity ?? CONFIG.SCREEN_SHAKE.INTENSITY;
        this.duration = duration ?? CONFIG.SCREEN_SHAKE.DURATION;
        this.timer = this.duration;
    }

    /**
     * 강한 흔들림 (보스 공격 등)
     */
    shakeStrong(): void {
        this.shake(CONFIG.SCREEN_SHAKE.INTENSITY * 2, CONFIG.SCREEN_SHAKE.DURATION * 1.5);
    }

    /**
     * 업데이트
     */
    update(deltaTime: number): void {
        if (this.timer > 0) {
            this.timer -= deltaTime;

            // 시간에 따라 강도 감쇠
            const progress = this.timer / this.duration;
            const currentIntensity = this.intensity * progress * CONFIG.SCREEN_SHAKE.DECAY;

            // 랜덤 오프셋 계산
            this.offsetX = (Math.random() - 0.5) * 2 * currentIntensity;
            this.offsetY = (Math.random() - 0.5) * 2 * currentIntensity;
        } else {
            // 흔들림 종료
            this.offsetX = 0;
            this.offsetY = 0;
            this.intensity = 0;
        }
    }

    /**
     * 현재 오프셋 반환
     */
    getOffset(): { x: number; y: number } {
        return { x: this.offsetX, y: this.offsetY };
    }

    /**
     * 흔들림 활성화 여부
     */
    isShaking(): boolean {
        return this.timer > 0;
    }

    /**
     * 리셋
     */
    reset(): void {
        this.intensity = 0;
        this.duration = 0;
        this.timer = 0;
        this.offsetX = 0;
        this.offsetY = 0;
    }
}
